import { Channel } from "./channel";

export class DelayedJobsChannel extends Channel {
  constructor(onRows) {
    super("Delayed::JobsChannel");
    this.onRows = onRows;
  }

  received(rows) {
    this.onRows(rows || []);
  }
}
